/**
 * Barèmes et taux de cotisations sociales 2025 (PLACEHOLDERS)
 * TODO: Brancher les barèmes officiels URSSAF/Agirc-Arrco depuis une API ou fichier de config
 * Ces valeurs sont approximatives et doivent être mises à jour selon les barèmes légaux
 */

// Plafond mensuel de la Sécurité Sociale 2025 (approximatif)
export const PMSS_2025 = 3864; // TODO: Mettre à jour avec valeur officielle

// SMIC horaire brut 2025 (approximatif)
export const SMIC_HORAIRE_2025 = 11.65; // TODO: Mettre à jour avec valeur officielle

// SMIC mensuel 2025 (base 151,67h)
export const SMIC_MENSUEL_2025 = SMIC_HORAIRE_2025 * 151.67; // ~1766€

/**
 * Cotisations URSSAF - Part salariale (%)
 * TODO: Brancher barèmes officiels
 */
export const COTISATIONS_SALARIE = {
  // Maladie-maternité (Alsace-Moselle : +1.50%)
  maladie: { rate: 0, label: 'Assurance maladie', code: 'MAL' },
  
  // Vieillesse plafonnée
  vieillesse_plaf: { rate: 6.90, label: 'Vieillesse (tranche 1)', code: 'VIEIL_T1', plafond: 1 },
  
  // Vieillesse déplafonnée
  vieillesse_deplaf: { rate: 0.40, label: 'Vieillesse déplafonnée', code: 'VIEIL_DEPLAF' },
  
  // CSG déductible
  csg_deductible: { rate: 6.80, label: 'CSG déductible', code: 'CSG_DED', assiette: 0.9825 },
  
  // CSG/CRDS non déductible
  csg_non_deductible: { rate: 2.40, label: 'CSG non déductible', code: 'CSG_ND', assiette: 0.9825 },
  crds: { rate: 0.50, label: 'CRDS', code: 'CRDS', assiette: 0.9825 },
  
  // Retraite complémentaire Agirc-Arrco
  retraite_t1: { rate: 3.15, label: 'Retraite complémentaire T1', code: 'ARRCO_T1', plafond: 1 },
  retraite_t2: { rate: 8.64, label: 'Retraite complémentaire T2', code: 'ARRCO_T2', plafond: 8, min_plafond: 1 },
  
  // CEG (Contribution d'équilibre général) - Agirc-Arrco
  ceg_t1: { rate: 0.86, label: 'CEG T1', code: 'CEG_T1', plafond: 1 },
  ceg_t2: { rate: 1.08, label: 'CEG T2', code: 'CEG_T2', plafond: 8, min_plafond: 1 },
};

/**
 * Cotisations URSSAF - Part employeur (%)
 * TODO: Brancher barèmes officiels
 */
export const COTISATIONS_EMPLOYEUR = {
  // Allocations familiales (taux réduit < 3.5 SMIC)
  allocations_familiales: { rate: 3.45, label: 'Allocations familiales', code: 'AF' },
  allocations_familiales_reduit: { rate: 0.10, label: 'Allocations familiales (taux réduit)', code: 'AF_RED' },
  
  // Assurance maladie
  maladie: { rate: 13.00, label: 'Assurance maladie', code: 'MAL_EMP' },
  
  // Solidarité autonomie
  solidarite: { rate: 0.30, label: 'Solidarité autonomie', code: 'SOLID' },
  
  // Vieillesse plafonnée
  vieillesse_plaf: { rate: 8.55, label: 'Vieillesse plafonnée', code: 'VIEIL_T1_EMP', plafond: 1 },
  
  // Vieillesse déplafonnée
  vieillesse_deplaf: { rate: 1.90, label: 'Vieillesse déplafonnée', code: 'VIEIL_DEPLAF_EMP' },
  
  // Chômage (taux général)
  chomage: { rate: 4.05, label: 'Assurance chômage', code: 'CHOMAGE', plafond: 4 },
  
  // AGS (garantie salaires)
  ags: { rate: 0.15, label: 'AGS', code: 'AGS', plafond: 4 },
  
  // Retraite complémentaire Agirc-Arrco
  retraite_t1: { rate: 4.72, label: 'Retraite complémentaire T1', code: 'ARRCO_T1_EMP', plafond: 1 },
  retraite_t2: { rate: 12.95, label: 'Retraite complémentaire T2', code: 'ARRCO_T2_EMP', plafond: 8, min_plafond: 1 },
  
  // CEG
  ceg_t1: { rate: 1.29, label: 'CEG T1', code: 'CEG_T1_EMP', plafond: 1 },
  ceg_t2: { rate: 1.62, label: 'CEG T2', code: 'CEG_T2_EMP', plafond: 8, min_plafond: 1 },
  
  // Formation professionnelle (< 11 salariés)
  formation_pro: { rate: 0.55, label: 'Formation professionnelle', code: 'FORM_PRO' },
  
  // Taxe d'apprentissage
  taxe_apprentissage: { rate: 0.68, label: 'Taxe d\'apprentissage', code: 'TAX_APP' },
  
  // Contribution CPF-CDD (si applicable)
  cpf_cdd: { rate: 1.00, label: 'CPF-CDD', code: 'CPF_CDD' },
};

/**
 * Taux de majoration heures supplémentaires
 */
export const TAUX_HEURES_SUP = {
  heures_125: 1.25, // 8 premières heures sup (ou selon accord)
  heures_150: 1.50, // Heures suivantes
};

/**
 * Jours fériés 2025 (France métropolitaine)
 * TODO: Calculer dynamiquement selon l'année
 */
export const JOURS_FERIES_2025 = [
  '2025-01-01', // Jour de l'an
  '2025-04-21', // Lundi de Pâques
  '2025-05-01', // Fête du travail
  '2025-05-08', // Victoire 1945
  '2025-05-29', // Ascension
  '2025-06-09', // Lundi de Pentecôte
  '2025-07-14', // Fête nationale
  '2025-08-15', // Assomption
  '2025-11-01', // Toussaint
  '2025-11-11', // Armistice 1918
  '2025-12-25', // Noël
];

/**
 * Calcule le nombre de jours ouvrés dans un mois
 * @param {number} year 
 * @param {number} month (1-12)
 * @returns {number}
 */
export function getWorkingDaysInMonth(year, month) {
  const daysInMonth = new Date(year, month, 0).getDate();
  let workingDays = 0;
  
  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(year, month - 1, day);
    const dayOfWeek = date.getDay();
    // Samedi (6) et Dimanche (0) exclus
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      workingDays++;
    }
  }
  
  return workingDays;
}

/**
 * Calcule le nombre de semaines dans un mois (approximatif)
 * @param {number} year 
 * @param {number} month (1-12)
 * @returns {number}
 */
export function getWeeksInMonth(year, month) {
  const workingDays = getWorkingDaysInMonth(year, month);
  return workingDays / 5; // 5 jours ouvrés par semaine
}
